import { Phone, Settings } from "lucide-react";
import { Link } from "@tanstack/react-router";

import { Reveal } from "@/components/site/Reveal";
import { business, services } from "@/lib/business";
import { slugify } from "@/lib/utils";

export function Services() {
  return (
    <section
      id="services"
      className="scroll-mt-28 border-b border-border py-20 sm:py-28"
      aria-labelledby="services-heading"
    >
      <div className="mx-auto max-w-6xl px-4">
        <Reveal>
          <p className="eyebrow">What we do</p>
          <h2 id="services-heading" className="mt-3 text-4xl uppercase sm:text-5xl">
            Engine machine services
          </h2>
          <p className="mt-4 max-w-2xl text-muted-foreground">
            We are a dedicated automotive machine shop. Everything we do is engine work — for cars,
            light and large trucks, diesel, industrial equipment, farm tractors and motorcycles.
            That includes valve seat and guide work, rotating assembly balancing, and lathe work.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <Reveal key={service.title} as="li" delay={index * 90} className="h-full">
              <Link
                to="/services"
                hash={slugify(service.title)}
                className="surface-card group block h-full p-6"
              >
                <Settings
                  className="size-8 text-primary-text transition-transform duration-500 group-hover:rotate-90"
                  aria-hidden="true"
                />
                <h3 className="mt-5 text-2xl uppercase">{service.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{service.body}</p>
                <span className="sr-only">View {service.title} details</span>
              </Link>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={200} className="mt-10">
          <div className="surface-card flex flex-col items-start gap-4 p-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-lg">
              Not sure what your block needs? Tell us what you have and we'll give you a straight
              answer.
            </p>
            <div className="flex shrink-0 flex-wrap gap-3">
              <a href={business.phoneHref} className="btn-base btn-primary">
                <Phone className="size-4" aria-hidden="true" />
                <span className="sr-only">Call </span>
                {business.phone}
              </a>
              <Link to="/services" className="btn-base btn-outline">
                All services
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
